<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
    /* @import "./assets/css/main.css"; */
    /* @import "./assets/css/color-dark.css";      */
    /*深色主题*/
    /*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/

    input{
      &::-webkit-credentials-auto-fill-button {
        display: none !important;
        visibility: hidden;
        pointer-events: none;
        position: absolute; 
        right: 0;
      }
      &:focus::-webkit-contacts-auto-fill-button{
        opacity: 0;
      }
    }

</style>